import styled from 'styled-components';
export const MultiSelectWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-end;
	align-items: center;
	> div {
		> div {
			> div {
				border-radius: 0;
			}
		}
	}
`;
